export default function identify(user, team) {
  if (process.env.NODE_ENV === 'development') console.log('track/identify', user, team);
  // We expect anonymous users to have no email or name -- skip them.
  // Some sign up methods may not have a name.
  let name, {email, first_name, last_name} = user;
  if (first_name && last_name) name = first_name + ' ' + last_name;
  if (!email) return;
  let team_name = (team && team.name) || null;

  // Intercom
  if (window.intercomSettings) {
    if (name) window.intercomSettings.name = name;
    if (email) window.intercomSettings.email = email;
  }

  // Drip.io
  if (window._dcq) {
    window._dcq.push(["identify", {
      email,
      first_name,
      last_name,
      team_name
    }]);
  }

  // User Pilot
  if (window.userpilot) {
    let identifyData = {
        // User data
        email,
        name: name,
        user_type: user.user_type,
        job_role: user.job_role,
        created_at: user.date_joined,

        // Derived data -- allows for simple A/B testing
        ab: 'ab'[user.id & 1],

        // Team data
        team_id: team.id,
        team_name: team.name,
        team_domain: team.domain,
        company_size: team.company_size,
        have_design: team.have_design
    };
    if (process.env.NODE_ENV === 'development') console.log('userpilot/identify', identifyData);
    window.userpilot.identify(user.id, identifyData);
  }

  // Amplitude
  if (window.amplitude) {
    let instance = window.amplitude.getInstance();
    instance.setUserId(email);
    instance.setUserProperties({first_name, last_name, email, team_name: team.name});
  }

  if (window.LogRocket) {
    window.LogRocket.identify(user.id, {
      name,
      email,
    })
  }
}



// WEBPACK FOOTER //
// ./src/lib/track/identify.js